import {  subYears } from "date-fns";

export function getBirthdateFromAge(age: number): Date {
  return subYears(new Date(), age);
}

export function getAgeFromBirthday(birthday: string): number {
  const birthDate =  new Date(birthday);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
   const monthDiff = today.getMonth() - birthDate.getMonth();

  // Adjust if birthday hasn't happened yet this year
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}